import watchRTC from '@testrtc/watchrtc-sdk'

type IWatchRTCConfiguration = Parameters<typeof watchRTC.init>[0]

class WatchRTCHandler {
  options: IWatchRTCConfiguration

  init(options?: { watchRTCConfigParams?: IWatchRTCConfiguration }) {
    if (options?.watchRTCConfigParams?.rtcApiKey) {
      watchRTC.init({
        rtcApiKey: options.watchRTCConfigParams.rtcApiKey,
      })

      this.options = { ...options.watchRTCConfigParams }
    }
  }

  start(roomName: string, userName: string, { tenantId, userId }: { tenantId: number; userId: number }) {
    try {
      if (this.options) {
        this.options = {
          ...this.options,
          rtcRoomId: roomName,
          rtcPeerId: userName,
          keys: {
            CollaborateEnv: process.env.TABEEB_WATCHRTC_ENVIRONMENT_NAME,
            CollaborateClientType: 'web',
            CollaborateJistiBuild: process.env.TABEEB_JITSI_BUILD_VERSION,
            CollaborateBridge: window.config?.hosts?.domain,
            CollaborateTenantID: tenantId,
            CollaborateClientID: userId,
          },
        }

        watchRTC.persistentEnd()
        watchRTC.setConfig(this.options)
      }
    } catch {
      // ignored
    }
  }
}

export default new WatchRTCHandler()
